import styled from 'styled-components';
import { PageTile } from '@make-software/cspr-design';
import { PropsWithChildren } from 'react';

const StyledPageTile = styled(PageTile)(({ theme }) =>
  theme.withMedia({
    margin: '0',
    height: 'fit-content',
  })
);

interface TileSideProps {}

export const TileSide = ({ children }: PropsWithChildren<TileSideProps>) => {
  return <StyledPageTile>{children}</StyledPageTile>;
};

export default TileSide;
